import * as tokens from '@cash-design-system/tokens'

const maxWidths = {
  content: '31rem',
  field: '27rem',
  page: tokens.BreakpointMax,
} as const

export type ThemeMaxWidths = typeof maxWidths

export default maxWidths
